import React, { useState } from 'react';
import Button from './Button.jsx';
import { authService } from '../services';

const CreateFirmForm = ({ onCreated }) => {
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        setError('');

        if (!name.trim()) {
            setError('Firm name is required.');
            return;
        }

        setIsLoading(true);
        try{
            const firm = await authService.createFirm({ name: name.trim() });
            setName('');
            onCreated(firm);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to create firm. Please try again or contact your service provider.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        // NOTE: intentionally a <div>, not a <form> — this component is rendered
        // inside Register.jsx's own <form>, and a nested <form> element causes
        // the submit event to be mishandled (the outer form's onSubmit also
        // fires), so the firm never actually gets created. See CreateFirmForm.
        <div>
            {error && <div className="error-banner">{error}</div>}
            <div className="add-user-field">
                <label className="input-label">Firm Name</label>
                <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g. Acme Consulting"
                className="ci-select"
             />
            </div>
            <Button type="button" onClick={handleSubmit} fullWidth disabled={isLoading}>
                {isLoading ? 'Creating...': 'Create Firm'}
            </Button>
        </div>
    );
};

export default CreateFirmForm;
